import * as React from 'react'
import { NextSeo } from 'next-seo'

import * as entity from '@boutique/entities'
import * as url from '@bob/url'

import { SITE_URL } from '@bob/config'

import { Why } from '../components/Why'
import { Who } from '../components/Who'
import { How } from '../components/How'
import { OurCriteria } from '../components/OurCriteria'
import { OurLabel } from '../components/OurLabel'

export type ManifestoProps = {
  manifesto: entity.manifesto.Manifesto
}

export type ManifestoNavItems = {
  id: string
  title: string
}[]

export function Manifesto({ manifesto }: ManifestoProps): React.ReactElement {
  return (
    <>
      <NextSeo
        title="Bien ou Bien : le guide des marques engagées"
        description="Découvrez des produits bien pour la planète et les humains"
        canonical={SITE_URL + url.manifesto().path}
        openGraph={{
          title: 'Bien ou Bien : le guide des marques engagées',
          description: 'Découvrez des produits bien pour la planète et les humains',
          url: SITE_URL,
          images: [
            {
              alt: 'Bien ou Bien, le magasin où acheter des biens tout simplement bien',
              url: SITE_URL + '/assets/images/bob_og_image.png',
            },
          ],
        }}
        robotsProps={{
          maxImagePreview: 'large',
        }}
      />
      <Why />
      <Who />
      <OurLabel />
      <OurCriteria manifesto={manifesto} />
      <How />
    </>
  )
}
